import React, { Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
import SignInContainer from '../containers/SignInContainer.jsx';
injectTapEventPlugin();

// This replaces the textColor value on the palette
// and then update the keys for each component that depends on it.
// More on Colors: http://www.material-ui.com/#/customization/colors
const muiTheme = getMuiTheme({
  textField: {
    textColor: "#30353a",
    focusColor: "#30353a",
    borderColor: "#30353a"
  },
  flatButton: {
    primaryTextColor: "#000",
    textColor: "#333",
  },
  floatingActionButton: {
    buttonSize: 70,
    color: "#F44336",
  }
});

// define and export our Layout component
export default class App extends Component {
  render () {
    const {
      children
    } = this.props;
    let clonedChildren = null;
    if (children) {
      clonedChildren = React.cloneElement(children, {
        auth: this.props.route.auth
      });
    }

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="wrapper">
          <SignInContainer auth={this.props.route.auth} />
          {clonedChildren}
        </div>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/App.jsx